<template>
<div class="card" v-loading.fullscreen.lock="loader">
  <div class="section-heading" align="center">RESULTS</div>
  <br>
  <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="top">
    <el-row>
      <el-col :span="11">
        <el-form-item label="Campus Name" prop="SelectedRole">
          <el-select v-model="form.SelectedRole"  placeholder="Select Campus Name">
            <el-option
                v-for="(item, key) in roles"
                :key="key"
                :label="key"
                :value="key">
              </el-option>
            </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="Exam Date" prop="date">
          <el-date-picker type="date" placeholder="Select Exam Start Date" v-model="form.date" style="width: 100%;"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <br>
    <el-row>
      <el-col>
        <el-form-item label="Enter Emails" prop="emails" >
          <el-input placeholder="abc@gmail.com,pqr@yahoo.com,etc..." v-model="form.emails" multiple>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <br>
  <div align="right">
    <el-button class="btn-theme" @click="changeRole()">Check Results</el-button>
  </div>
  <br>
  <br>
  <div v-if="ShowTable">
    <el-row>
      <result-table :tableData="finalResult"></result-table>
    </el-row>
  </div>
  <br>
  <br>
  <div align="right" v-if="ShowTable">
    <el-button class="btn-theme"><a :href="encodedUri" download="result.csv" style="text-decoration:none; color: white;">Download Result</a></el-button>
  </div>
</div>
</template>
<script>
import moment from 'moment'
import DownloadResult from './DownloadResult'
import ResultTable from './ResultTable'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    ResultTable,
    DownloadResult
  },
  data () {
    var validateEmails = (rule, value, callback) => {
      if (value) {
        var arr = value.split(', ')
        arr.forEach(ele => {
          var atpos = ele.indexOf('@')
          var dotpos = ele.lastIndexOf('.')
          if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= ele.length) {
            callback(new Error('Please input correct email id'))
          }
        })
        callback()
      } else {
        callback(new Error('Enter Email Id'))
      }
    }
    return {
      ShowTable: false,
      encodedUri: '',
      download: false,
      loader: false,
      roles: [],
      result: [],
      finalResult: [],
      DownloadArr: [],
      form: {
        SelectedRole: '',
        date: '',
        emails: '',
        emailArr: []
      },
      rules: {
        SelectedRole: [
          { required: true, message: 'Select Campus Name', trigger: 'change' }
        ],
        date: [
          { required: true, message: 'Select Exam Date', trigger: 'change' }
        ],
        emails: [
          { validator: validateEmails, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getSurveyRoles: 'Survey/getSurveyRoles',
      getResult: 'Survey/getResult'
    })
  },
  methods: {
    ...mapActions({
      fetchSurveyRoles: 'Survey/fetchSurveyRoles',
      fetchResult: 'Survey/fetchResult'
    }),
    printResult () {
      let Arr = []
      let csvFinalArr = []
      let csv1 = []
      csv1.push('First Name')
      csv1.push('Email')
      csv1.push('Quantitative Aptitude')
      csv1.push('Data Interpretation')
      csv1.push('Coding Ability')
      csv1.push('Total')
      csvFinalArr.push(csv1)
      this.result.forEach(ele => {
        let data = {}
        let csvArr = []
        data.name = ele['First Name']
        data.email = ele['Email']
        data.sectionA = ele['Quantitative Aptitude']
        data.sectionB = ele['Data Interpretation']
        data.sectionC = ele['Coding Ability']
        data.total = ele.Total
        csvArr.push(data.name)
        csvArr.push(data.email)
        csvArr.push(data.sectionA)
        csvArr.push(data.sectionB)
        csvArr.push(data.sectionC)
        csvArr.push(data.total)
        csvFinalArr.push(csvArr)
        Arr.push(data)
      })
      this.finalResult = Arr
      this.DownloadArr = csvFinalArr
      this.loader = false
      this.ShowTable = true
      let csvContent = 'data:text/csv;charset=utf-8,'
      this.DownloadArr.forEach(function (rowArray) {
        let row = rowArray.join(',')
        csvContent += row + '\r\n'
      })
      this.encodedUri = encodeURI(csvContent)
    },
    changeRole (value) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          var EmaiArr = this.form.emails.split(', ')
          this.loader = true
          this.fetchResult({
            role: this.form.SelectedRole,
            exam_date: moment(this.form.date).format('MM-DD-YYYY'),
            emails: EmaiArr
          })
        }
      })
    }
  },
  watch: {
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success) {
        this.roles = value.data
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    getResult (value) {
      console.log('Get results get calleddddddddd', value)
      if (value.success === true) {
        this.result = value.data
        this.printResult()
        this.$message.success(value.message)
      } else {
        this.loader = false
        this.$message.error(value.message)
      }
    },
    SelectedRole (value) {
    },
    finalResult (value) {
      console.log('Final Result', value)
    }
  },
  mounted () {
    this.loader = true
    this.fetchSurveyRoles()
    // this.roles = this.getSurveyRoles
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Result/Result.vue